import React from "react";
import Section from "./Section";
import * as content from "../content";

export default function Invitation() {
  const { invitation: inv } = content;
  return (
    <Section id="invitation">
      <h2 className="section-title">{inv.heading}</h2>
      {inv.paragraphs.map((p, i) => (
        <p key={i} className="prose">
          {p}
        </p>
      ))}
    </Section>
  );
}
